import React, { useCallback } from 'react';
import { Alert } from 'components/Alert/Alert';
import { Error } from '@mui/icons-material';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

interface OfflineAlertProps {
  showOfflineAlert: boolean;
  dismissAlert: () => void;
}

export const OfflineAlert: React.FC<OfflineAlertProps> = ({ showOfflineAlert, dismissAlert }) => {
  const { translation } = useTranslationContext();
  const { isMobile } = useDeviceType();

  return (
    <Alert
      isPresented={showOfflineAlert}
      variant="filled"
      severity="error"
      message={translation('offline_toast_message')}
      anchorOrigin={{ vertical: isMobile ? 'bottom' : 'top', horizontal: 'center' }}
      icon={<Error />}
      snackbarSx={{ position: 'fixed', top: { sm: 80, md: 8 } }}
      handleDismiss={dismissAlert}
    />
  );
};
